import { configureStore, createSlice } from '@reduxjs/toolkit'

let cart = createSlice({
    name:'cart',
    initialState:[
    ],

    reducers:{
        addCount(state, action){
            let idx = state.findIndex((a)=>{return a.id===action.payload})
            
            
            ++state[idx].amount;
        },
        disCount(state, action){
            let idx = state.findIndex((a)=>{return a.id===action.payload})
            if(state[idx].amount<=1){
                alert("1개 이상 구매 가능합니다.")
            }else{
                --state[idx].amount;
            }
            
        },

        sortName(state){
            state.sort((a,b)=>a.item>b.item ? 1: -1,);
        },
        addItem(state, action){
            let idx = state.findIndex((a)=>{return a.id===action.payload.id})
            if(idx>=0){
               ++state[idx].amount
            }else{
                state.push(action.payload)
            }
            
        },

    }
})
export let {addCount, disCount, sortName, addItem} = cart.actions

export default configureStore({

  reducer: {
    cart:cart.reducer
  }

}) 